import { Check } from '#components/Check'
import { Image, IMAGES } from '#components/Image'
import { useTasks } from '#hooks'
import { Button, PanelBody, Spinner } from '@wordpress/components'
import { useTranslation } from 'react-i18next'

export const KeywordInASubheader = ({ pop }) => {
  const { t } = useTranslation()
  const { tasks, isValidating, mutate } = useTasks(pop)
  const condition = tasks?.['keyonhx'].pass

  const check = () => {
    mutate()
  }

  return (
    <PanelBody
      title={t('sidebar.keywordinasubheader.title')}
      icon={isValidating ? <Spinner /> : <Check condition={condition} />}
      initialOpen={!condition}
    >
      <p>{t('sidebar.keywordinasubheader.intro')}</p>
      <Image src={IMAGES.KEYWORD_IN_A_SUBHEADER} />
      <Button variant="primary" onClick={check}>
        Check!
      </Button>
    </PanelBody>
  )
}
